// extracted by mini-css-extract-plugin
export var editButton = "_pn-0";